import Vue from "vue";
import Router from "vue-router";
import { Auth } from "aws-amplify";
import store from "./store";

import MegaApp from "./views/MegaApp";
import Setting from "./components/Setting";
import Logout from "./components/Logout";
import AppList from "./components/AppList";
import AuthencationTemplate from "./template/Authencation";

Vue.use(Router);

const confirmSignIn = (to, from, next) => {
  Auth.currentAuthenticatedUser()
    .then(user => {
      store.dispatch("auth/callSetAccountInfo", user);
      store.dispatch("auth/callSetSignedIn", true);
      Auth.currentCredentials()
        .then(credentials => {
          store.commit("auth/setUserId", credentials.identityId);
        })
        // eslint-disable-next-line no-console
        .catch(err => console.log(err));
      next();
    })
    .catch(err => {
      if (err) {
        store.dispatch("auth/callSetAccountInfo", null);
        store.dispatch("auth/callSetSignedIn", false);
        next("/auth");
      }
    });
};

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: MegaApp,
      beforeEnter: confirmSignIn,
      children: [
        {
          path: "",
          name: "home",
          component: AppList
        },
        {
          path: "setting",
          name: "setting",
          component: Setting
        },
        {
          path: "logout",
          name: "logout",
          component: Logout
        }
      ]
    },
    {
      path: "/auth",
      name: "authencation",
      component: AuthencationTemplate
    }
  ]
});